/**
 * @module animationNumbers
 */

module.exports = function( numberAnimationElements ) {
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: .4,
    };

    function animateNumber( element ) {
        const targetNumber = parseInt( element.getAttribute( 'data-target' ), 10 );
        const duration = parseInt( element.getAttribute( 'data-duration' ), 10 ) || 2000;
        const endText = element.getAttribute( 'data-end-text' ) || '';
        const text = element.getAttribute( 'data-text' ) || '';
        const startTime = performance.now();

        function updateNumber( currentTime ) {
            const progress = Math.min( ( currentTime - startTime ) / duration, 1 );
            const value = Math.floor( progress * targetNumber );
            element.textContent = value + text;

            if ( progress < 1 ) {
                requestAnimationFrame( updateNumber );
            } else {
                element.textContent = targetNumber + text + endText;
            }
        }

        requestAnimationFrame( updateNumber );
    }

    function handleIntersection( entries, observer ) {
        entries.forEach( ( entry ) => {
            if ( entry.isIntersecting ) {
                animateNumber( entry.target );
                observer.unobserve( entry.target );
            }
        } );
    }

    const observer = new IntersectionObserver( handleIntersection, observerOptions );

    numberAnimationElements.forEach( ( element ) => {
        observer.observe( element );
    } );
};
